// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false,\"minimize\":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-44a7be2f\",\"scoped\":true,\"sourceMap\":false}!../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./addOrEditXygl.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("7101702a", content, true, {"shadowMode":false,"sourceMap":false});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader?{"shadowMode":false,"sourceMap":false}!./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-44a7be2f","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/medDoc/parts/addOrEditXygl.vue
// module id = nV/W
// module chunks = 0